export default {
    FROG_HOST: 'https://frog.yuanfudao.ws/statV2/plain',
};
